module.exports = __webpack_public_path__ + "img/favicon.c83a078.webp";